import { DeclarationHighValueGroupType, EnvironmentCountries } from '@e-origin/shared';

import { TableNotificationIndicator } from '@components';
import { countCustomsStateNotifications } from '../../helpers';
import { DeclarationViewCustoms } from './DeclarationViewCustoms';
import { DeclarationViewCustomsProof } from './DeclarationViewCustomsProof';
import { DeclarationViewCustomsTreatment } from './DeclarationViewCustomsTreatment';
import { DeclarationViewDocuments } from './DeclarationViewDocuments';
import { DeclarationViewDV1 } from './DeclarationViewDV1';
import { DeclarationViewGeneralInfo } from './DeclarationViewGeneralInfo';
import { DeclarationViewGoodList } from './DeclarationViewGoodList';
import { DeclarationViewStakeholders } from './DeclarationViewStakeholders';

interface DeclarationViewTab {
  value: string;
  label: string;
  condition: boolean;
  component: React.ReactNode;
  icon?: React.ReactNode;
  iconCondition?: boolean;
}

const customsStateNotificationIcon = (declarationDetails): React.ReactNode => {
  const { actionsPending, notificationsPending } = countCustomsStateNotifications(declarationDetails);

  return <TableNotificationIndicator actionsPending={actionsPending} notificationsPending={notificationsPending} />;
};

export const useBuildDeclarationViewTabsData = ({ declarationDetails, editDisabled, settings, isHighValue, isHighValueBE, status }) => {
  const builtTabs: DeclarationViewTab[] = [
    {
      value: 'goods-shipment',
      label: 'Goods Shipment',
      condition: true,
      component: <DeclarationViewGoodList declaration={declarationDetails} editDisabled={editDisabled} generalInfo={declarationDetails?.generalInfo} />,
    },
    {
      value: 'general-info',
      label: 'General Info',
      condition: true,

      component: <DeclarationViewGeneralInfo declaration={declarationDetails} editDisabled={editDisabled} />,
    },
    {
      value: 'stakeholders',
      label: 'Stakeholders',
      condition: true,
      component: <DeclarationViewStakeholders declaration={declarationDetails} editDisabled={editDisabled} />,
    },
    {
      value: 'documents',
      label: 'Documents',
      condition: !settings?.isForwarder,
      component: <DeclarationViewDocuments declaration={declarationDetails} editDisabled={editDisabled} />,
    },
    {
      value: 'dv1',
      label: 'DV1',
      condition:
        isHighValueBE &&
        !settings?.isForwarder &&
        !(declarationDetails?.generalInfo?.group === DeclarationHighValueGroupType.H2 && settings.country === EnvironmentCountries.BE),
      component: <DeclarationViewDV1 declaration={declarationDetails} editDisabled={editDisabled} />,
    },
    {
      value: 'customs-treatment',
      label: 'Customs Treatment',
      condition: declarationDetails?.generalInfo?.group !== DeclarationHighValueGroupType.H2,
      component: <DeclarationViewCustomsTreatment declaration={declarationDetails} editDisabled={editDisabled} />,
    },
    {
      value: 'customs-state',
      label: 'Customs State',
      condition: true,
      icon: customsStateNotificationIcon(declarationDetails),
      component: <DeclarationViewCustoms declaration={declarationDetails} status={status} />,
    },
    {
      value: 'customs-proof',
      label: 'Customs Proof',
      condition: settings?.walletEnabled && !isHighValue && !settings?.isForwarder,
      component: <DeclarationViewCustomsProof declaration={declarationDetails} status={status} />,
    },
  ];

  return { builtTabs };
};
